import React from 'react';
import {WhiteContainer} from '../../../components';

export default () => (
  <WhiteContainer>
    <span>Customization</span>
  </WhiteContainer>
);
